export enum EDataSynchronizerSourceType {
	Control,
	DataSource
}
